import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LeadContato } from '../lead-contato';

@Component({
    selector: 'sgt-lead-contato-list-group',
    templateUrl: './lead-contato-list-group.component.html',
    styleUrls: ['./lead-contato-list-group.component.less']
})
export class LeadContatoListGroupComponent {
    /** Contatos do lead */
    @Input() contatos: LeadContato[] = [];
    /** Se pode abrir um contato */
    @Input() canOpen = true;
    /** Evento para abrir um contato */
    @Output() open = new EventEmitter<LeadContato>();
    /** Tamanho da fonte dos textos de contato */
    @Input() fontSize = '10px';

    openClick(contato: LeadContato) {
        if (!this.canOpen) {
            return;
        }
        this.open.emit(contato);
    }
}
